<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
export default {
    name: 'App',
	data() {
		return {
		}
	},
    created() {
		if(window.innerWidth > 768) {  //pc端
			this.$store.commit('setType', 'pc');
		}else{  //移动端
			this.$store.commit('setType', 'mobile');
		}
    }
}
</script>
<style lang="less" scoped>
	#app{
		width: 100%;
		height: 100%;
    	background: #F0F5FE;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue